const str = '';
const dateTimeStr = new Date()?.toISOString();

export const buildingContractModelGet = ({ buildingId = '', contractId = '', userId = '', }) => {
    return {
        buildingId: buildingId,
        contractId: contractId,
        userId: userId,
        controlNumber: str,
        created: dateTimeStr,
        dateStart: dateTimeStr,
        dateEnd: dateTimeStr,
        invoice: str,
        remark: str,
        subContractId: str,
    }
};